// extracted by mini-css-extract-plugin
module.exports = {"Label":"OnHandItemQuickInput_Label__3oKAW","Display":"OnHandItemQuickInput_Display__23nig"};